import React, { ComponentProps } from 'react';
import DatePicker from '../copy/DatePicker';
import useIsReadOnlyMode from '../compiler/hooks/useIsReadOnlyMode';

type DatePickerProps = ComponentProps<typeof DatePicker>;

type Props = Omit<DatePickerProps, 'initialDate' | 'onChange' | 'maxDate' | 'minDate'> & {
  name: string;
  defaultValue: string | null;
  onChanged(name: string, newDateOnly: string | null): void;
  maxValueType?: 'today-inclusive';
  minValueType?: 'today-inclusive';
};

/**
 * A handy adapter to work with DateOnly objects received from back-end.
 * The calling code just passes around yyyy-mm-dd dates, not a crappy JS Date object
 */
const WizardDateOnlyPicker: React.FC<Props> = ({
  name,
  defaultValue,
  onChanged,
  maxValueType,
  minValueType,
  disabled,
  ...otherProps
}) => {
const isReadOnly = useIsReadOnlyMode() || disabled;

  let maxDate: Date | undefined = undefined;
  if (maxValueType === 'today-inclusive') {
    maxDate = setTimeToNoon(new Date());
  }

  let minDate: Date | undefined = undefined;
  if (minValueType === 'today-inclusive') {
    minDate = setTimeToNoon(new Date());
  }

  return (
    <DatePicker
      initialDate={defaultValue ? yyyyMmDdToLocalDate(defaultValue) : null}
      onChange={(e) => {
        const newValue = e.value instanceof Date ? localDateToYyyyMmDd(e.value) : null;
        onChanged(name, newValue);
      }}
      dateFormat="yy-mm-dd" // actually, this displays year with 4 numbers, not 2: 2001-01-01 =/
      maxDate={maxDate}
      minDate={minDate}
      disabled={isReadOnly}
      {...otherProps}
    />
  );
};

export default WizardDateOnlyPicker;

function localDateToYyyyMmDd(date: Date): string {
  const yyyy = date.getFullYear();
  const mm = (date.getMonth() + 1).toString().padStart(2, '0');
  const dd = date.getDate().toString().padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

function yyyyMmDdToLocalDate(yyyyMmDd: string): Date {
  return new Date(yyyyMmDd + 'T12:00:00');
}

function setTimeToNoon(date: Date): Date {
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date;
}
